<div class="command-action-icon">
  <ng-container *ngFor="let command of allowedCommands">
    <ng-container *ngIf="!command.active || !command.onActiveCommand; else aciveCommand">
      <!-- TO DO: change this tag or find the reason of having a class in an ng-container -->
      <ng-container
        *ngIf="command.isVisibleBySelectedCommand == null || command.isVisibleBySelectedCommand(currentActiveCommand)"
      >
        <div class="command-action-container" [ngClass]="{ 'command-action-container--disable': command.isDisabled }">
          <a
            *ngIf="command.visible"
            [ngClass]="[command.className || 'command-action', command.isDisabled ? 'command-action--disabled' : '']"
            [attr.data-track-action-scope]="command.actionScope"
            [attr.data-track-action-identifier]="command.actionIdentifier"
            (click)="applyCommand(command)"
          >
            <mat-icon
              class="link-icon"
              *ngIf="command.icon"
              [matTooltip]="command.toolTip | xTranslate"
              [svgIcon]="command.icon"
            ></mat-icon>

            <span [matTooltip]="command.toolTip | xTranslate" class="commands-links">
              {{ command.title | xTranslate | uppercase }}</span
            >
          </a>
          <mat-icon
            class="warning-icon"
            *ngIf="command.warningIcon"
            [matTooltip]="command.toolTip | xTranslate"
            [svgIcon]="command.warningIcon"
          ></mat-icon>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #aciveCommand>
      <a
        *ngIf="command.visible"
        [ngClass]="command.className || 'command-action'"
        [attr.data-track-action-scope]="command.actionScope"
        [attr.data-track-action-identifier]="command.actionIdentifier"
        (click)="applyActiveCommand(command)"
      >
        <mat-icon
          class="link-icon"
          *ngIf="command.icon"
          [svgIcon]="command.onActiveCommandIcon || command.icon"
        ></mat-icon>
        {{ command.activeTitle | xTranslate }}
      </a>
    </ng-template>
  </ng-container>
</div>
